"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.splitDynamicFilterString = splitDynamicFilterString;
exports.buildDynamicFilterLookupFromString = buildDynamicFilterLookupFromString;
exports.getValuesFromDynamicFilterLookup = getValuesFromDynamicFilterLookup;
exports.getValuesFromDynamicFilterString = getValuesFromDynamicFilterString;
exports.getRangeValuesFromDynamicFilterLookup = getRangeValuesFromDynamicFilterLookup;
exports.getDateRangeValuesFromDynamicFilterLookup = getDateRangeValuesFromDynamicFilterLookup;
exports.getStatusValueFromDynamicFilterLookup = getStatusValueFromDynamicFilterLookup;
exports.getMultiSelectValuesFromDynamicFilterLookup = getMultiSelectValuesFromDynamicFilterLookup;
exports.getOrderingFromDynamicOrderString = getOrderingFromDynamicOrderString;
exports.makeDynamicFilterString = makeDynamicFilterString;
exports.makeDynamicFilterBetweenString = makeDynamicFilterBetweenString;
exports.makeDynamicFilterRangeString = makeDynamicFilterRangeString;
exports.queryParamsToDynamicQueryLanguageParams = queryParamsToDynamicQueryLanguageParams;
const lib_1 = require("../string/lib.js");
const dayjs_1 = __importDefault(require("dayjs"));
const sonar_ts_types_1 = require("@sonar-software/sonar-ts-types");
const nonSequentialDoubleQuotes = /(?<!")"(?!")/gu;
function splitDynamicFilterString(filterString) {
    const results = [];
    if (!filterString) {
        return results;
    }
    return filterString.split(/ +(?=(?:(?:[^"]*"){2})*[^"]*$)/gu);
}
function buildDynamicFilterLookupFromString(filterString) {
    return splitDynamicFilterString(filterString).reduce((prev, current) => {
        const [key, operator, ...rest] = current.split('~');
        const entry = {
            operator: operator,
            value: rest.join('~').replace(nonSequentialDoubleQuotes, '')
                .replace(/%/gu, '')
        };
        if (!prev[key]) {
            prev[key] = [];
        }
        prev[key].push(entry);
        return prev;
    }, {});
}
function getValuesFromDynamicFilterLookup(filter, lookup) {
    var _a;
    return (_a = lookup[filter]) !== null && _a !== void 0 ? _a : [];
}
function getValuesFromDynamicFilterString(filter, filterString) {
    return getValuesFromDynamicFilterLookup(filter, buildDynamicFilterLookupFromString(filterString));
}
function getRangeValuesFromDynamicFilterLookup(filter, lookup) {
    const results = [null, null];
    const entries = getValuesFromDynamicFilterLookup(filter, lookup);
    if (!entries.length) {
        return results;
    }
    entries.forEach((entry) => {
        if (entry.operator === sonar_ts_types_1.DynamicQueryOperator.GreaterThanOrEqualTo) {
            results[0] = Number(entry.value);
        }
        else {
            results[1] = Number(entry.value);
        }
    });
    return results;
}
function getDateRangeValuesFromDynamicFilterLookup(filter, lookup) {
    const results = [null, null];
    const entries = getValuesFromDynamicFilterLookup(filter, lookup);
    if (!entries.length) {
        return results;
    }
    entries.forEach((entry) => {
        if (entry.operator === sonar_ts_types_1.DynamicQueryOperator.GreaterThanOrEqualTo) {
            results[0] = (0, dayjs_1.default)(entry.value);
        }
        else {
            results[1] = (0, dayjs_1.default)(entry.value);
        }
    });
    return results;
}
function getStatusValueFromDynamicFilterLookup(filter, lookup) {
    var _a;
    const value = (_a = getValuesFromDynamicFilterLookup(filter, lookup)[0]) === null || _a === void 0 ? void 0 : _a.value;
    if (!value) {
        return null;
    }
    return Number(value);
}
function getMultiSelectValuesFromDynamicFilterLookup(filter, lookup, useNullString) {
    const valueEntries = getValuesFromDynamicFilterLookup(filter, lookup);
    if (!valueEntries.length) {
        return [];
    }
    const [{ operator, value }] = valueEntries;
    switch (operator) {
        case sonar_ts_types_1.DynamicQueryOperator.BetweenWithNull:
        case sonar_ts_types_1.DynamicQueryOperator.Between:
        case sonar_ts_types_1.DynamicQueryOperator.Inn:
        case sonar_ts_types_1.DynamicQueryOperator.In:
        case sonar_ts_types_1.DynamicQueryOperator.NotIn:
            const values = [];
            if (operator === sonar_ts_types_1.DynamicQueryOperator.Inn) {
                values.push(useNullString ? 'null' : -1);
            }
            values.push(...value.split('~').map((id) => (isNaN(Number(id)) ? id.replaceAll(nonSequentialDoubleQuotes, '') : Number(id))));
            if (operator === sonar_ts_types_1.DynamicQueryOperator.Between) {
                values.push(true);
            }
            return values;
        case sonar_ts_types_1.DynamicQueryOperator.IsNull:
            return useNullString ? ['null'] : [-1];
        default:
            return [];
    }
}
function getOrderingFromDynamicOrderString(orderString, sortOptions) {
    if (!orderString || !sortOptions.length) {
        return null;
    }
    const [sortBy, sortDirection] = orderString.split('~');
    const targetOption = sortOptions.find((option) => option.key === sortBy);
    if (targetOption) {
        const direction = sortDirection === 'a' ? sonar_ts_types_1.SonarV3SortDirection.Ascending : sonar_ts_types_1.SonarV3SortDirection.Descending;
        return Object.assign(Object.assign({}, targetOption), { direction });
    }
    return null;
}
function shouldAddQuotes(value) {
    return value !== null && isNaN(Number(value));
}
function makeDynamicFilterString(key, value, operator) {
    switch (operator) {
        case sonar_ts_types_1.DynamicQueryOperator.Between:
        case sonar_ts_types_1.DynamicQueryOperator.BetweenWithNull:
        case sonar_ts_types_1.DynamicQueryOperator.BitwiseOr:
        case sonar_ts_types_1.DynamicQueryOperator.BitwiseOrWithNull:
        case sonar_ts_types_1.DynamicQueryOperator.Equals:
        case sonar_ts_types_1.DynamicQueryOperator.GreaterThan:
        case sonar_ts_types_1.DynamicQueryOperator.GreaterThanOrEqualTo:
        case sonar_ts_types_1.DynamicQueryOperator.In:
        case sonar_ts_types_1.DynamicQueryOperator.Inn:
        case sonar_ts_types_1.DynamicQueryOperator.LessThan:
        case sonar_ts_types_1.DynamicQueryOperator.LessThanOrEqualTo:
        case sonar_ts_types_1.DynamicQueryOperator.NotEqual:
        case sonar_ts_types_1.DynamicQueryOperator.NotIn:
            let parsedValue = '';
            if (Array.isArray(value)) {
                parsedValue = value.map((part) => (shouldAddQuotes(part) ? `"${part}"` : part)).join('~');
            }
            else {
                parsedValue = shouldAddQuotes(value) ? `"${value}"` : String(value);
            }
            return parsedValue ? `${key}~${operator}~${parsedValue}` : '';
        case sonar_ts_types_1.DynamicQueryOperator.IsNull:
        case sonar_ts_types_1.DynamicQueryOperator.NotNull:
            return `${key}~${operator}`;
        case sonar_ts_types_1.DynamicQueryOperator.Like:
        case sonar_ts_types_1.DynamicQueryOperator.NotLike:
            return value ? `${key}~${operator}~"%${value}%"` : '';
        default:
            return '';
    }
}
function makeDynamicFilterBetweenString(key, value) {
    const [start, end, excludeNulls] = value;
    if (isNaN(Number(start)) || isNaN(Number(end))) {
        return '';
    }
    const operator = excludeNulls ? sonar_ts_types_1.DynamicQueryOperator.Between : sonar_ts_types_1.DynamicQueryOperator.BetweenWithNull;
    return makeDynamicFilterString(key, [Number(start), Number(end)], operator);
}
function makeDynamicFilterRangeString(key, value) {
    const [start, end] = value;
    const rangeArray = [];
    if (start) {
        rangeArray.push(makeDynamicFilterString(key, start, sonar_ts_types_1.DynamicQueryOperator.GreaterThanOrEqualTo));
    }
    if (end) {
        rangeArray.push(makeDynamicFilterString(key, end, sonar_ts_types_1.DynamicQueryOperator.LessThanOrEqualTo));
    }
    return rangeArray.join(' ');
}
function queryParamsToDynamicQueryLanguageParams(queryParams, options) {
    var _a, _b, _c, _d, _e;
    let filters = '';
    const { sortBy, sortDirection } = queryParams, rest = __rest(queryParams, ["sortBy", "sortDirection"]);
    const filtersCapitalize = ((_a = options === null || options === void 0 ? void 0 : options.capitalizeFilterParams) !== null && _a !== void 0 ? _a : true) ? lib_1.capitalize : (param) => param;
    const orderingCapitalize = ((_b = options === null || options === void 0 ? void 0 : options.capitalizeOrderingParams) !== null && _b !== void 0 ? _b : true) ? lib_1.capitalize : (param) => param;
    Object.entries((_c = options === null || options === void 0 ? void 0 : options.filterParams) !== null && _c !== void 0 ? _c : {}).forEach(([defaultKey, filterOptions]) => {
        var _a, _b, _c;
        const defaultValue = queryParams[defaultKey];
        let value = filterOptions.value ? filterOptions.value(defaultValue) : defaultValue;
        delete rest[defaultKey];
        if (filterOptions.rangeEnd) {
            delete rest[filterOptions.rangeEnd];
        }
        if (typeof value === 'undefined') {
            return;
        }
        const key = filtersCapitalize((_a = filterOptions.name) !== null && _a !== void 0 ? _a : defaultKey);
        let operator = (_c = (_b = filterOptions.operator) !== null && _b !== void 0 ? _b : options === null || options === void 0 ? void 0 : options.defaultOperator) !== null && _c !== void 0 ? _c : sonar_ts_types_1.DynamicQueryOperator.Equals;
        if (Array.isArray(value)) {
            const values = value;
            if (values.includes('null') || values.includes(-1)) {
                operator = values.length === 1 ? sonar_ts_types_1.DynamicQueryOperator.IsNull : sonar_ts_types_1.DynamicQueryOperator.Inn;
                value = values.filter((x) => x !== -1 && x !== 'null');
            }
            else {
                operator = sonar_ts_types_1.DynamicQueryOperator.In;
            }
        }
        const newFilter = filterOptions.rangeEnd ?
            makeDynamicFilterRangeString(key, [value, queryParams[filterOptions.rangeEnd]]) :
            makeDynamicFilterString(key, value, operator);
        const space = newFilter && filters ? ' ' : '';
        filters = `${filters}${space}${newFilter}`;
    });
    if (options === null || options === void 0 ? void 0 : options.removeParams) {
        options.removeParams.forEach((param) => {
            delete rest[param];
        });
    }
    const direction = sortDirection === sonar_ts_types_1.SonarV3SortDirection.Ascending ? 'a' : 'd';
    const orderingString = (_e = (_d = options === null || options === void 0 ? void 0 : options.orderingParams) === null || _d === void 0 ? void 0 : _d[String(sortBy)]) !== null && _e !== void 0 ? _e : sortBy;
    const ordering = sortBy && Number.isInteger(sortDirection) ?
        `${orderingCapitalize(String(orderingString))}~${direction}` : '';
    return Object.assign(Object.assign({}, rest), { filters,
        ordering });
}
//# sourceMappingURL=lib.js.map